function _openNotifDetail(row) {
  if (!row || !row.dataset.detailUrl) return;
  var modal = document.getElementById('inboxDetailModal');
  if (!modal || typeof modal.showModal !== 'function') return;
  htmx.ajax('GET', row.dataset.detailUrl, '#inbox-detail-body');
  modal.showModal();
}

function _closeInboxDetailModal() {
  var modal = document.getElementById('inboxDetailModal');
  if (modal && typeof modal.close === 'function') modal.close();
}

window.initInbox = function (el) {
  // Refresh button — triggers the HTMX reload event on the inbox root
  var refreshBtn = el.querySelector('[data-role="refresh"]');
  if (refreshBtn) {
    refreshBtn.addEventListener('click', function () {
      var inbox = document.getElementById('ssr-inbox');
      if (inbox) htmx.trigger(inbox, 'reload');
    });
  }

  // Notification rows — open detail modal on click or Enter/Space keydown.
  // Skip when the event originates from the mark-unread button so that button
  // doesn't also open the modal.
  el.addEventListener('click', function (e) {
    if (e.target.closest('[data-role="mark-unread"]')) return;
    var row = e.target.closest('[data-role="notif-row"]');
    if (row) _openNotifDetail(row);
  });

  el.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (e.target.closest('[data-role="mark-unread"]')) return;
    var row = e.target.closest('[data-role="notif-row"]');
    if (!row) return;
    e.preventDefault();
    _openNotifDetail(row);
  });

  // Close-modal button inside the dialog
  el.addEventListener('click', function (e) {
    if (!e.target.closest('[data-role="close-modal"]')) return;
    _closeInboxDetailModal();
  });

  // Modal backdrop click
  var backdrop = el.querySelector('[data-role="modal-backdrop"]');
  if (backdrop) {
    backdrop.addEventListener('click', function () {
      _closeInboxDetailModal();
    });
  }
};
